import { PersonToUpdateProfile } from './../../../../model/personAccount';
import { PersonToProfile } from 'model/personAccount';
import { GiroWebappError } from 'model/error';
import { action } from 'typesafe-actions';
import { PersonUpdateProfileActionTypes } from './types';

export const personUpdateProfileRequest = (request: PersonToUpdateProfile) => action(PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_REQUEST, request);
export const personUpdateProfileSuccess = (profile: PersonToProfile) => action(PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_SUCCESS, profile);
export const personUpdateProfileError = (error: GiroWebappError) => action(PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_ERROR, error);
export const personUpdateProfileResetState = () => action(PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_RESET_STATE);